import { render, staticRenderFns } from "./TimeToMarketChart.vue?vue&type=template&id=4d889d1c&"
import script from "./TimeToMarketChart.vue?vue&type=script&lang=js&"
export * from "./TimeToMarketChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports